export default "__VITE_ASSET__8d3ff643__"